<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>批次模块</el-breadcrumb-item>
            <el-breadcrumb-item>批次列表</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="grid-content">
      <el-col :span="8">
        <div>
          批次名称：
          <el-input v-model="input" style="width: unset;" placeholder="请输入批次名称"></el-input>
        </div>
      </el-col>
      <el-col :span="8">
        <div>
          状态:
          <el-select v-model="value" placeholder>
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="8">
        <el-button type="primary" size="medium" @click="handleCurrentChange(1)">查询</el-button>
        <el-button type="primary" size="medium" @click="add">新增</el-button>
      </el-col>
    </el-row>
    <el-table :data="tableData" border style="width: 95%">
      <el-table-column prop="title" label="批次名称" width="180"></el-table-column>
      <el-table-column prop="total" label="总件数" width="80"></el-table-column>
      <el-table-column prop="processCount" label="工序个数" width="80"></el-table-column>
      <el-table-column prop="laborcost" label="单件成本（元）" width="120"></el-table-column>
      <el-table-column prop="totalLaborcost" label="人工成本（元）" width="120"></el-table-column>
      <el-table-column prop="state" label="状态" width="80"></el-table-column>
      <el-table-column prop="checkStates" label="工序确认" width="80"></el-table-column>
      <el-table-column prop="startDate" label="开始时间"></el-table-column>
      <el-table-column prop="finishDate" label="结束时间"></el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button @click="goDetails(scope.row)" type="text" size="small">详情</el-button>
          <el-button
            v-if="scope.row.progress==0"
            @click="start(scope.row)"
            type="text"
            size="small"
          >开始</el-button>
          <el-button
            v-if="scope.row.progress==1"
            @click="end(scope.row)"
            type="text"
            size="small"
          >结束</el-button>
          <el-button
            v-if="scope.row.progress==0"
            @click="del(scope.row)"
            type="text"
            size="small"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="grid-content"
      background
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      :page-count="pageTotal"
    ></el-pagination>

    <!-- Form -->
    <el-dialog title="新增批次" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="批次名称:">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="批次总数:">
          <el-input v-model="form.number" type="number"></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="form.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  batchSel,
  batchAdd,
  batchDel,
  batchStart,
  batchComplete
} from "@/api/batch";
import { getBatchStates, setBatchStates,getCheckState } from "@/util/enum";
export default {
  data() {
    return {
      input: "",
      options: setBatchStates(),
      value: "",
      totalCount: 0,
      pageSize: 10,
      pageNum: 1,
      pageTotal: 0,
      tableData: [],
      dialogFormVisible: false,
      form: {
        title: "",
        number: "",
        remark: ""
      }
    };
  },
  mounted() {
    this.getBatchList();
  },
  methods: {
    handleClick(row) {
      console.log(row);
    },
    goDetails(row) {
      this.$router.push({ path: "batchdetails", query: { id: row.id } });
    },
    add() {
      this.dialogFormVisible = true;
    },
    batchAdd() {
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        title: this.form.title,
        total: this.form.number,
        remark: this.form.remark
      };
      batchAdd(params)
        .then(res => {
          if (res.count == 1) {
            this.$message({
              type: "success",
              message: "新增成功!"
            });
            this.dialogFormVisible = false;
            this.handleCurrentChange(1);
            this.$router.push({ path: "batchdetails", query: { id: res.id } });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    del(row) {
      this.$confirm(
        "此操作会删除<" + row.title + ">批次及其属工序, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          batchDel({ id: row.id })
            .then(() => {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.handleCurrentChange(1);
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    handleCurrentChange(e) {
      this.pageNum = e;
      this.getBatchList();
    },
    getBatchList() {
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        username: localStorage.getItem("user_name"),
        title: this.input,
        progress: this.value,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      batchSel(params)
        .then(res => {
          this.totalCount = res.page.total_count;
          this.pageTotal = res.page.page_total;
          this.tableData = [];
          res.gridData.forEach(element => {
            element.state = getBatchStates(element.progress);
            element.checkStates=getCheckState(element.checkState)
            this.tableData.push(element);
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    start(row) {
      this.$confirm(
        "批次开始后将不能再对其及其工序进行修改, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          batchStart({ id: row.id })
            .then(() => {
              this.$message({
                type: "success",
                message: "开始成功!"
              });
              this.handleCurrentChange(1);
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    end(row) {
      if(row.checkState==0){
        this.$message({
                type: "error",
                message: "请先确认工序才能结束！"
              });
        return
      }
      this.$confirm("批次结束后将不能再上报此批次的工作， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          batchComplete({ id: row.id })
            .then(() => {
              this.$message({
                type: "success",
                message: "结束成功!"
              });
              this.handleCurrentChange(1);
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => {});
    }
  }
};
</script>
